import { connect } from 'react-redux';
import {
  setSelectedCategory,
  removePartConfig,
  updatePartsConfig,
  setAvailableCategories,
  setCurrentText,
  openAlertDialog,
  setCurrentActiveParent,
  setShouldReapplyCustomization,
  setFrontBikeNumberPlate,
  setBackBikeNumberPlate,
  setFrontBikeText,
  setBackBikeText,
  setHotspot
} from '../customizer.duck';
import { setIsConfigSaved, setIsLoading } from '../common.duck';
import Controller from '../../modules/Controller';

const mapStateToProps = ({ common, customizer }) => ({
  data: common.data,
  partsConfig: customizer.partsConfig,
  currentActiveParent: customizer.currentActiveParent,
  selectedCategory: customizer.selectedCategory,
  allCategories:
    customizer.availableVariants[customizer.selectedVariant]
      .customizationCategories,
  availableCategories: customizer.availableCategories,
  activeHotspot: customizer.activeHotspot,
  allAvailableCustomizations: customizer.availableCustomizations,
  availableCustomizations:
    customizer.availableCustomizations[customizer.selectedCategory],
  availableColors: customizer.availableCustomizations.baseColor,
  currentText: customizer.currentText,
  selectedVariant: customizer.selectedVariant,
  reapplyCustomization: customizer.reapplyCustomization,
  tShirtBikeFrontNumberPlate: customizer.tShirtBikeFrontNumberPlate,
  tShirtBikeBackNumberPlate: customizer.tShirtBikeBackNumberPlate,
  tShirtBikeFrontText: customizer.tShirtBikeFrontText,
  tShirtBikeBackText: customizer.tShirtBikeBackText
});

const mapDispatchToProps = dispatch => ({
  setSelectedCategory: category => {
    dispatch(setSelectedCategory(category));
  },
  removePartConfig: category => {
    dispatch(removePartConfig(category));
  },
  updatePartsConfig: (data, category, ignoredList) => {
    dispatch(updatePartsConfig(data, category, ignoredList));
  },
  setShouldReapplyCustomization: bool => {
    dispatch(setShouldReapplyCustomization(bool));
  },
  setAvailableCategories: data => {
    dispatch(setAvailableCategories(data));
  },
  setCurrentText: (text, rotateTo) => {
    dispatch(setCurrentText(text, rotateTo));
  },
  setIsLoading: bool => {
    dispatch(setIsLoading(bool));
  },
  openAlertDialog: alertInfo => {
    dispatch(openAlertDialog(alertInfo));
  },
  setIsConfigSaved: () => {
    dispatch(setIsConfigSaved(false));
  },
  setCurrentActiveParent: category => {
    dispatch(setCurrentActiveParent(category));
  },
  setFrontBikeNumberPlate: (line, uOffset, vOffset, fontSize, width) => {
    dispatch(setFrontBikeNumberPlate(line, uOffset, vOffset, fontSize, width));
  },
  setBackBikeNumberPlate: (line, uOffset, vOffset, fontSize, width) => {
    dispatch(setBackBikeNumberPlate(line, uOffset, vOffset, fontSize, width));
  },
  setFrontBikeText: line => {
    dispatch(setFrontBikeText(line));
  },
  setBackBikeText: line => {
    dispatch(setBackBikeText(line));
  },
  setHotspot: hotspotCode => {
    dispatch(setHotspot(hotspotCode));
  }
  //   setShouldShowSidePane: bool => {
  //     dispatch(setShouldShowSidePane(bool));
  //   }
  //   disablePart: partId => {
  //     dispatch(disablePart(partId));
  //   }
});

export default connect(mapStateToProps, mapDispatchToProps)(Controller);
